import React, { useContext } from 'react';
import { mergeStyleSets, FontSizes, Link, FontWeights } from '@fluentui/react';

import { ApiError } from 'services/restService';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';

export interface DetailBoxProps {
	error: ApiError
}

const styles = mergeStyleSets({
	root: {
		background: '#f3f2f1',
		padding: '0.25rem',
		fontSize: FontSizes.size12,
		maxWidth: '450px',
		'& ul': {
			margin: 0,
			padding: 0,
			listStyle: 'none'
		}
	},
	listItem: {
		display: 'flex',
		alignItems: 'center',
	},
	listKey: {
		color: '#605e5c',
		fontWeight: FontWeights.semibold
	},
	listValue: {
		color: '#605e5c'
	}
});

export const DetailBox = ({ error: { status, title, type, detail, traceId } }: DetailBoxProps) => {
	const { t } = useContext(TranslationsContext)!;

	return (
		<div className={styles.root}>
			<ul aria-label={t(translationKeys.DetailBox.AriaLabel)}>
				{	status &&
					<li>
						<span className={styles.listKey}>{t(translationKeys.DetailBox.Status)} </span>
						<span className={styles.listValue}>{status}</span>
					</li>
				}
				{	title &&
					<li>
						<span className={styles.listKey}>{t(translationKeys.DetailBox.Title)} </span>
						<span className={styles.listValue}>{title}</span>
					</li>
				}
				{ type &&
					<li>
						<span className={styles.listKey}>{t(translationKeys.DetailBox.Type)} </span>
						<span className={styles.listValue}>{type}</span>
					</li>
				}
				{	detail &&
					<li>
						<span className={styles.listKey}>{t(translationKeys.DetailBox.Detail)} </span>
						<span className={styles.listValue}>{detail}</span>
					</li>
				}
				{	traceId &&
					<li>
						<span className={styles.listKey}>{t(translationKeys.DetailBox.CorrelationId)} </span>
						<span className={styles.listValue}>{traceId}</span>
					</li>
				}
			</ul>
			<Link underline={true} target='_blank' href='https://admin.powerplatform.microsoft.com/support/'>{t(translationKeys.DetailBox.LinkText)}</Link>
		</div>
	);
};

DetailBox.defaultProps = {
	error: {}
};
